<section class="px-4 py-20" aria-labelledby="trust-heading">
  <div class="max-w-6xl mx-auto">
    <div class="text-center mb-12">
      <h2 id="trust-heading" class="text-2xl sm:text-3xl font-bold text-silk-white">
        Tu compra segura y respaldada de principio a fin
      </h2>
      <p class="text-silk-white/60 text-sm mt-3 max-w-xl mx-auto">
        Diseñamos cada etapa de tu experiencia de compra para ofrecerte total tranquilidad, desde el primer clic hasta que recibes tu pedido.
      </p>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
      
      <!-- Garantía 1: Pagos Seguros -->
      <app-galaxy-card padding="lg" class="h-full">
        <div galaxy-card-content class="flex flex-col h-full text-center sm:text-left">
          <div class="w-12 h-12 rounded-2xl bg-cyan-500/10 border border-cyan-500/20 flex items-center justify-center mb-6 mx-auto sm:mx-0">
            <svg class="w-6 h-6 text-cyan-400" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
            </svg>
          </div>
          <h3 class="font-semibold text-silk-white text-lg mb-2">Transacciones Protegidas</h3>
          <p class="text-silk-white/60 text-sm leading-relaxed">
            Procesa tus pagos con total seguridad a través de pasarelas internacionales cifradas como PayPal.
          </p>
        </div>
      </app-galaxy-card>

      <!-- Garantía 2: Soporte WhatsApp -->
      <app-galaxy-card padding="lg" class="h-full">
        <div galaxy-card-content class="flex flex-col h-full text-center sm:text-left">
          <div class="w-12 h-12 rounded-2xl bg-emerald-500/10 border border-emerald-500/20 flex items-center justify-center mb-6 mx-auto sm:mx-0">
            <svg class="w-6 h-6 text-emerald-400" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 01-2.555-.337A5.972 5.972 0 015.41 20.97a5.969 5.969 0 01-.474-.065 4.48 4.48 0 00.978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25z" />
            </svg>
          </div>
          <h3 class="font-semibold text-silk-white text-lg mb-2">Asesoría Inmediata</h3>
          <p class="text-silk-white/60 text-sm leading-relaxed">
            ¿Tienes dudas sobre un producto? Te atendemos directamente por WhatsApp para ayudarte a elegir con confianza.
          </p>
        </div>
      </app-galaxy-card>

      <!-- Garantía 3: Envíos Asegurados -->
      <app-galaxy-card padding="lg" class="h-full">
        <div galaxy-card-content class="flex flex-col h-full text-center sm:text-left">
          <div class="w-12 h-12 rounded-2xl bg-amber-500/10 border border-amber-500/20 flex items-center justify-center mb-6 mx-auto sm:mx-0">
            <svg class="w-6 h-6 text-amber-400" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-9m18-0v-7.5A2.25 2.25 0 0017.25 9H15M6.75 11.25V6.75A2.25 2.25 0 019 4.5h6a2.25 2.25 0 012.25 2.25v4.5" />
            </svg>
          </div>
          <h3 class="font-semibold text-silk-white text-lg mb-2">Envíos Garantizados</h3>
          <p class="text-silk-white/60 text-sm leading-relaxed">
            Empaque especializado y seguimiento en tiempo real para que tu pedido llegue en perfectas condiciones.
          </p>
        </div>
      </app-galaxy-card>

    </div>
  </div>
</section>
